import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	height: 435px;
	overflow-y: scroll;
	padding: 0 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledBrightnessContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	border-radius: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledSliderContainer = styled.div`
	width: 140px;
`;

const StyledWallpaperContainer = styled.div`
	padding: 20px;
	border-radius: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	margin-top: 20px;

	& > ${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledWallpaperGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 20px;
`;

const StyledWallpaperItem = styled.div`
	position: relative;
	height: 200px;
	padding: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledWallpaperButton = styled.button`
	position: absolute;
	bottom: 10px;
	left: 10px;
	width: calc(100% - 20px);
	height: 30px;
	background-color: #2d70da;
	border-radius: 5px;
	border: none;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	color: #ffffff;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:disabled {
		background-color: rgba(255, 255, 255, 0.1);
		color: rgba(255, 255, 255, 0.5);
		cursor: default;
	}

	&:hover:not(:disabled) {
		background-color: #ffffff;
		color: #000000;
	}
`;

export {
	StyledBrightnessContainer,
	StyledContainer,
	StyledHead,
	StyledSliderContainer,
	StyledWallpaperButton,
	StyledWallpaperContainer,
	StyledWallpaperGrid,
	StyledWallpaperItem,
};
